<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <b-card no-body>
                    <b-tabs v-model="tabIndex" card>
                        <b-tab title="ยอดขายปรับระดับปี 2023-2025" active>

                            <!-- <div class="card-title h3 pb-2">ค้นหา</div> -->
                            <form action="" class="" @submit.prevent="validateForm" novalidate ref="frmSubmit">
                                <div class="row d-flex align-items-end">

                                    <!-- <FormInput name="AgentId" type="text" label="รหัสสมาชิก [เปิดให้แก้ไขชั่วคราว]" v-model="filter.AgentId"
                                    placeholder="รหัสสมาชิก" @validate="validate" :error="errors.AgentId"
                                    :requireField="true" formGroupClass="form-group col-xl-3 col-md-4" /> -->

                                    <FormMonth name="DateStart" type="date" label="ตั้งแต่เดือน"
                                        v-model="filter.DateStart" placeholder="วันที่จ่ายเงิน" @validate="validate"
                                        :error="errors.DateStart" :require-field="true"
                                        :maxDate="'2025-12-31'"
                                        formGroupClass="form-group col-xl-2 offset-xl-2 col-md-4" />

                                    <FormMonth name="DateEnd" type="date" label="ถึงเดือน" v-model="filter.DateEnd"
                                        placeholder="ถึงวันที่จ่ายเงิน" @validate="validate" :error="errors.DateEnd"
                                        :maxDate="'2025-12-31'"
                                        :require-field="true" formGroupClass="form-group col-xl-2 col-md-4" />

                                    <div class="col-xl-4 col-md-12 form-group">
                                        <button type="button" class="btn btn-primary" :disabled="isDownload"
                                            @click="submitReqSum" v-show="checkPermission(['ReadPayment'])">
                                            <b-spinner small v-if="isDownloadReqSum"></b-spinner>
                                            ยอดขายทั้งหมด
                                        </button>
                                        <button type="button" class="btn btn-secondary ml-2" :disabled="isDownload"
                                            @click="submitDownload" v-show="checkPermission(['ReadPayment'])">
                                            <b-spinner small v-if="isDownload"></b-spinner>
                                            Download Excel
                                        </button>
                                    </div>
                                </div>

                            </form>


                        </b-tab>
                        <b-tab title="ยอดขายปรับระดับปี 2026 เป็นต้นไป">
                            <form action="" class="" @submit.prevent="validateFormNew" novalidate ref="frmSubmitNew">
                                <div class="row d-flex align-items-end">

                                    <!-- <FormInput name="AgentId" type="text" label="รหัสสมาชิก [เปิดให้แก้ไขชั่วคราว]" v-model="filter.AgentId"
                                    placeholder="รหัสสมาชิก" @validate="validate" :error="errors.AgentId"
                                    :requireField="true" formGroupClass="form-group col-xl-3 col-md-4" /> -->

                                    <FormMonth name="DateStart" type="date" label="ตั้งแต่เดือน"
                                        v-model="filterNew.DateStart" placeholder="วันที่จ่ายเงิน" @validate="validateNew"
                                        :error="errorsNew.DateStart" :require-field="true"
                                        :minDate="'2026-01-01'"
                                        formGroupClass="form-group col-xl-2 offset-xl-2 col-md-4" />

                                    <FormMonth name="DateEnd" type="date" label="ถึงเดือน" v-model="filterNew.DateEnd"
                                        placeholder="ถึงวันที่จ่ายเงิน" @validate="validateNew" :error="errorsNew.DateEnd"
                                        :minDate="'2026-01-01'"
                                        :require-field="true" formGroupClass="form-group col-xl-2 col-md-4" />

                                    <div class="col-xl-4 col-md-12 form-group">
                                        <button type="button" class="btn btn-primary" :disabled="isDownload"
                                            @click="submitReqSumNew" v-show="checkPermission(['ReadPayment'])">
                                            <b-spinner small v-if="isDownloadReqSum"></b-spinner>
                                            ยอดขายทั้งหมด
                                        </button>
                                        <button type="button" class="btn btn-secondary ml-2" :disabled="isDownload"
                                            @click="submitDownloadNew" v-show="checkPermission(['ReadPayment'])">
                                            <b-spinner small v-if="isDownload"></b-spinner>
                                            Download Excel
                                        </button>
                                    </div>
                                </div>

                            </form>
                        </b-tab>

                        <div class="row" v-show="reqSumData.TotalSum != null">
                            <div class="col-xl-8  offset-xl-2 col-md-12 text-center p-4 text-primary">
                                <b-alert show variant="success" class="shadow">
                                    <div class="h4 text-primary leadz font-weight-bold">
                                        ยอดขายทั้งหมดที่สามารถปรับระดับ
                                    </div>
                                    <hr>
                                    <div class="h3 text-primary leadx font-weight-bold">{{
                                        moneyFormatFull(reqSumData.TotalAvaiUpLevel) }}</div>
                                </b-alert>

                                <!-- <table class="m-auto h4 text-primary" cellpadding="4">
                                        <tr>
                                            <th class="text-right">ยอดขายทั้งหมด</th>
                                            <td class="text-right">{{ moneyFormatFull(reqSumData.TotalSum) }}</td>
                                        </tr>
                                        <tr>
                                            <th class="text-right">ยอดขายทั้งหมดที่สามารถปรับระดับ</th>
                                            <td class="text-right">{{ moneyFormatFull(reqSumData.TotalSum) }}</td>
                                        </tr>
                                    </table> -->
                            </div>
                        </div>
                    </b-tabs>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from '@/components/layouts/main'
import PageHeader from '@/components/page-header'
import FormMonth from "@/components/FormMonth"

let self;
/**
 * Customers component
 */
export default {
    page: {
        title: 'รายงานยอดขายปรับระดับ',
        meta: [{ name: 'description' }],
    },
    components: {
        Layout,
        PageHeader,
        FormMonth,
    },
    data() {
        var yup = this.yup
        return {
            title: 'รายงานยอดขายปรับระดับ',
            items: [
                {
                    text: 'SKLife',
                    to: { name: 'home' }
                },
                {
                    text: 'รายงานยอดขายปรับระดับ',
                    active: true
                },
            ],
            VUE_APP_OFFICEAPI_URL: process.env.VUE_APP_OFFICEAPI_URL,
            tabIndex: 0,
            isReqCmd: "",
            isDownload: false,
            isDownloadReqSum: false,
            reqSumData: {
                TotalSum: null,
                TotalAvaiUpLevel: null
            },
            filter: {
                AgentId: "",
                DateStart: this.$dayjs().isAfter(this.$dayjs('2025-12-31')) ? this.$dayjs('2025-12-31').endOf('month').format('YYYY-MM') : this.$dayjs().startOf('month').format('YYYY-MM'),
                DateEnd: this.$dayjs().isAfter(this.$dayjs('2025-12-31')) ? this.$dayjs('2025-12-31').endOf('month').format('YYYY-MM') : this.$dayjs().endOf('month').format('YYYY-MM'),
            },
            filterNew: {
                AgentId: "",
                DateStart: this.$dayjs().isBefore(this.$dayjs('2026-01-01')) ? this.$dayjs('2026-01-01').endOf('month').format('YYYY-MM') : this.$dayjs().startOf('month').format('YYYY-MM'),
                DateEnd: this.$dayjs().isBefore(this.$dayjs('2026-01-01')) ? this.$dayjs('2026-01-01').endOf('month').format('YYYY-MM') : this.$dayjs().endOf('month').format('YYYY-MM'),
            },
            errors: {
                AgentId: "",
                DateStart: "",
                DateEnd: "",
            },
            errorsNew: {
                AgentId: "",
                DateStart: "",
                DateEnd: "",
            },
            FormSchema: yup.object().shape({
                AgentId: yup.string().test('empty-check', 'ค้นหาไม่น้อยกว่า 4 ตัวอักษร', AgentId => AgentId.length >= 4),
                DateStart: yup.date().nullable().required('กรุณาระบุเดือนเริ่มต้น'),
                DateEnd: yup.date().nullable().required('กรุณาระบุเดือนสิ้นสุด'),
            }),
            FormSchemaNew: yup.object().shape({
                AgentId: yup.string().test('empty-check', 'ค้นหาไม่น้อยกว่า 4 ตัวอักษร', AgentId => AgentId.length >= 4),
                DateStart: yup.date().nullable().required('กรุณาระบุเดือนเริ่มต้น'),
                DateEnd: yup.date().nullable().required('กรุณาระบุเดือนสิ้นสุด'),
            }),
        }
    },
    async created() {
        self = this;
    },
    async mounted() {
        await this.getAgentId()
    },
    methods: {
        submitReqSum() {
            console.log('submsubmitReqSumitDownload');
            self.isReqCmd = "REQSUM";
            this.validateForm();
        },
        submitReqSumNew() {
            console.log('submitReqSumNew');
            self.isReqCmd = "REQSUMNEW";
            this.validateFormNew();
        },
        submitDownload() {
            self.isReqCmd = "REQDOWNLOAD";
            this.validateForm();
        },
         submitDownloadNew() {
            self.isReqCmd = "REQDOWNLOADNEW";
            this.validateFormNew();
        },
        validateForm() {
            this.FormSchema
                .validate(this.filter, { abortEarly: false })
                .then(() => {
                    if (self.isReqCmd == "REQDOWNLOAD")
                        this.downloadExcel(this.filter);
                    else if (self.isReqCmd == "REQSUM")
                        this.reqSum(this.filter);
                })
                .catch(err => {
                    err.inner.forEach(error => {
                        this.errors = { ...this.errors, [error.path]: error.message };
                    });
                });
        },
        validateFormNew() {
            this.FormSchemaNew
                .validate(this.filter, { abortEarly: false })
                .then(() => {
                    if (self.isReqCmd == "REQDOWNLOADNEW")
                        this.downloadExcelNew(this.filterNew);
                    else if (self.isReqCmd == "REQSUMNEW")
                        this.reqSumNew(this.filterNew);
                })
                .catch(err => {
                    err.inner.forEach(error => {
                        this.errorsNew = { ...this.errorsNew, [error.path]: error.message };
                    });
                });
        },
        validate(field) {
            this.FormSchema
                .validateAt(field, this.filter)
                .then(() => {
                    this.errors[field] = "";
                })
                .catch(err => {
                    this.errors[err.path] = err.message;
                });
        },
        validateNew(field) {
            this.FormSchemaNew
                .validateAt(field, this.filterNew)
                .then(() => {
                    this.errorsNew[field] = "";
                })
                .catch(err => {
                    this.errorsNew[err.path] = err.message;
                });
        },
        async getAgentId() {
            this.isBusy = true
            const config = {
                headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` },
            };
            await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/whtc/getagentid/' + this.$store.state.Admin.RefId, config)
                .then(function (res) {
                    if (res.status == 200) {
                        self.filter.AgentId = res.data;
                        self.filterNew.AgentId = res.data;
                    } else {
                        self.$swal('เกิดข้อผิดพลาด');
                    }
                    self.isBusy = false
                })
                .catch(function (error) {
                    self.$swal('เกิดข้อผิดพลาด');
                    self.isBusy = false
                });
        },
        downloadExcel(filter) {
            try {
                self.isDownload = true;
                const config = {
                    headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
                    responseType: 'blob',
                    params: {
                        AgentId: filter.AgentId,
                        DateStart: filter.DateStart + '-01',
                        DateEnd: filter.DateEnd + this.$dayjs(filter.DateEnd + '-01').endOf('month').format('-DD'),
                    }
                };
                this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/report/getagentorderappuplevel', config)
                    .then(function (res) {
                        if (res.status == 200) {
                            const filename = 'AgentOrderUpLevelReport_' + self.$dayjs().format('YYYY_MM_DD_HH_mm_ss') + '.xlsx';
                            self.saveAs(res.data, filename);
                        } else {
                            self.$swal('เกิดข้อผิดพลาด1');
                        }
                        self.isDownload = false;
                    })
                    .catch(function (error) {
                        self.$swal('เกิดข้อผิดพลาด2');
                        self.isDownload = false;
                    });
            } catch (error) {
                return null
            }
        },
         downloadExcelNew(filter) {
            try {
                self.isDownload = true;
                const config = {
                    headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
                    responseType: 'blob',
                    params: {
                        AgentId: filter.AgentId,
                        DateStart: filter.DateStart + '-01',
                        DateEnd: filter.DateEnd + this.$dayjs(filter.DateEnd + '-01').endOf('month').format('-DD'),
                    }
                };
                this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/report/getagentorderappuplevelnew', config)
                    .then(function (res) {
                        if (res.status == 200) {
                            const filename = 'AgentOrderUpLevelReport_' + self.$dayjs().format('YYYY_MM_DD_HH_mm_ss') + '.xlsx';
                            self.saveAs(res.data, filename);
                        } else {
                            self.$swal('เกิดข้อผิดพลาด1');
                        }
                        self.isDownload = false;
                    })
                    .catch(function (error) {
                        self.$swal('เกิดข้อผิดพลาด2');
                        self.isDownload = false;
                    });
            } catch (error) {
                return null
            }
        },
        reqSum(filter) {
            try {
                self.isDownloadReqSum = true;
                const config = {
                    headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
                    params: {
                        AgentId: filter.AgentId,
                        DateStart: filter.DateStart + '-01',
                        DateEnd: filter.DateEnd + this.$dayjs(filter.DateEnd + '-01').endOf('month').format('-DD'),
                    }
                };

                console.log(filter.DateStart, filter.DateEnd)

                this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/report/getagentorderappuplevelsum', config)
                    .then(function (res) {
                        if (res.status == 200) {
                            console.log(res.data);
                            self.reqSumData = res.data;
                        } else {
                            self.$swal('เกิดข้อผิดพลาด1');
                        }
                        self.isDownloadReqSum = false;
                    })
                    .catch(function (error) {
                        self.$swal('เกิดข้อผิดพลาด2');
                        self.isDownloadReqSum = false;
                    });
            } catch (error) {
                return null
            }
        },
        reqSumNew(filter) {
            try {
                self.isDownloadReqSum = true;
                const config = {
                    headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
                    params: {
                        AgentId: filter.AgentId,
                        DateStart: filter.DateStart + '-01',
                        DateEnd: filter.DateEnd + this.$dayjs(filter.DateEnd + '-01').endOf('month').format('-DD'),
                    }
                };

                console.log(filter.DateStart, filter.DateEnd)

                this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/report/getagentorderappuplevelsumnew', config)
                    .then(function (res) {
                        if (res.status == 200) {
                            console.log(res.data);
                            self.reqSumData = res.data;
                        } else {
                            self.$swal('เกิดข้อผิดพลาด1');
                        }
                        self.isDownloadReqSum = false;
                    })
                    .catch(function (error) {
                        self.$swal('เกิดข้อผิดพลาด2');
                        self.isDownloadReqSum = false;
                    });
            } catch (error) {
                return null
            }
        }
    },
    watch: {
        tabIndex: {
            handler: function () {
                self.reqSumData = { TotalSum: null, TotalAvaiUpLevel: null };
            }
        },
        'filter.AgentId': {
            handler: function () {
                self.reqSumData = { TotalSum: null, TotalAvaiUpLevel: null };
            }
        },
        'filter.DateStart': {
            handler: function () {
                self.reqSumData = { TotalSum: null, TotalAvaiUpLevel: null };

                if (this.filter.DateStart > this.filter.DateEnd)
                    this.filter.DateEnd = this.filter.DateStart;
            }
        },
        'filter.DateEnd': {
            handler: function () {
                self.reqSumData = { TotalSum: null, TotalAvaiUpLevel: null };

                if (this.filter.DateStart > this.filter.DateEnd)
                    this.filter.DateStart = this.filter.DateEnd;
            }
        },

    }
}
</script>